import React, { createContext, useEffect, useState, useCallback } from "react";
import { useAuth } from "./AuthContext";
import axios from 'axios';
import configs from "config";

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);
  const { id } = useAuth();
  const chaveCarrinho = `cart-guest`;

  const saveCartItemsToServer = useCallback((cartItems) => {
      axios.post(configs.api + "save-cart-products", { cartItems, id })
        .then(response => {
          console.log('Produtos do carrinho salvos no servidor com sucesso');
        })
        .catch(error => {
          console.error('Erro ao salvar produtos do carrinho no servidor:', error);
        });
  }, [id]);

  const loadUserCart = useCallback(async () => {
    if (id) {
      try {
        const response = await axios.get(configs.api + `get-cart/${id}`);
        const userCart = response.data || []; 
        const localStorageCart = JSON.parse(localStorage.getItem(chaveCarrinho)) || [];
        const uniqueProductIds = new Set();

        localStorageCart?.map((product) => uniqueProductIds.add(product.id));
        userCart.map((product) => uniqueProductIds.add(product.id));

        const mergedCart = [];

        uniqueProductIds.forEach((productId) => {
          const product = localStorageCart.find((product) => product.id === productId);
          if (product) {
            mergedCart.push(product);
          } else {
            const product = userCart.find((product) => product.id === productId);
            if (product) {
              mergedCart.push(product);
            }
          }
        });

        setCartItems(mergedCart);
        saveCartItemsToServer(mergedCart);
        localStorage.setItem(chaveCarrinho, JSON.stringify([]))
      } catch (error) {
        console.error('Erro ao carregar carrinho do usuário:', error);
      }
    }
  }, [id, saveCartItemsToServer, chaveCarrinho]);

  useEffect(() => {
    if (id) {
      loadUserCart();
    } else {
      setCartItems([]);
    }
  }, [id, loadUserCart]);

    // NOVO useEffect para sincronizar entre abas
  useEffect(() => {
    const handleStorageChange = (event) => {
      // Verifica se a mudança foi na nossa chave do carrinho e se há um novo valor
      if (event.key === chaveCarrinho && event.newValue) {
        console.log("LocalStorage foi atualizado em outra aba. Sincronizando...");
        setCartItems(JSON.parse(event.newValue));
      }
    };

    // Adiciona o event listener
    window.addEventListener('storage', handleStorageChange);

    // Função de limpeza para remover o listener quando o componente desmontar
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [chaveCarrinho]); // A dependência é a chave, caso ela mude (ex: login/logout)


  const addToCart = (product) => {
    const existingProductIndex = cartItems.findIndex((item) => item.id === product.id);
    
    // Evita adicionar produtos duplicados
    if (existingProductIndex !== -1) {
      return; 
    }

    const updatedCartItems = [...cartItems, { ...product }];

    setCartItems(updatedCartItems);
    localStorage.setItem(chaveCarrinho, JSON.stringify(updatedCartItems));
    
    if (id) {
      saveCartItemsToServer(updatedCartItems);
    }
  };

  const removeFromCart = (productId) => {
    const updatedCartItems = cartItems.filter((item) => item.id !== productId);
    
    setCartItems(updatedCartItems);
    localStorage.setItem(chaveCarrinho, JSON.stringify(updatedCartItems));

    if (id) {
      saveCartItemsToServer(updatedCartItems);
    }
  };

  const clearCart = () => {
    setCartItems([]);
    saveCartItemsToServer([]);
    localStorage.setItem(chaveCarrinho, JSON.stringify([]))
  };
  // const addToCart = (product) => {
  //   const existingProductIndex = cartItems.findIndex((item) => item.id === product.id);
  //   const updatedCartItems = existingProductIndex !== -1
  //     ? [...cartItems]
  //     : [...cartItems, { ...product }];

  //   localStorage.setItem(chaveCarrinho, JSON.stringify(updatedCartItems));
  //   saveCartItemsToServer(updatedCartItems);
  //   setCartItems(updatedCartItems);

  // };

  useEffect(() => {
    let cartItemsStorage = [];
    const localStorageGuest = localStorage.getItem("cart-guest");
    if(localStorageGuest){
      cartItemsStorage =  JSON.parse(localStorage.getItem("cart-guest"))
    }
    setCartItems(cartItemsStorage);
  }, []);

  // const removeFromCart = (productId) => {
  //   const updatedCartItems = cartItems.filter((item) => item.id !== productId);
  //   localStorage.setItem(chaveCarrinho, JSON.stringify(updatedCartItems));
  //   setCartItems(updatedCartItems);
  //   saveCartItemsToServer(updatedCartItems);
  // };

  const decreaseQuantity = (productId) => {
    const updatedCartItems = cartItems.map((item) => {
      if (item.id === productId) {
        return {
          ...item,
        };
      }
      return item;
    });

    setCartItems(updatedCartItems);
  };

  const increaseQuantity = (productId) => {
    const updatedCartItems = cartItems.map((item) => {
      if (item.id === productId) {
        return {
          ...item,
        };
      }
      return item;
    });

    setCartItems(updatedCartItems);
  };

  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        removeFromCart,
        decreaseQuantity,
        increaseQuantity,
        clearCart 

      }}
    >
      {children}
    </CartContext.Provider>
  );
};
